import { default as ClearIconMUI } from '@mui/icons-material/Clear';

export const ClearIcon = ClearIconMUI;
